import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'

import { useQueryParams } from '@/hooks/useQueryParams'
import Home from '@/screens/Home/Home'
import Match from '@/screens/Match/Match'

const AppContent = () => {
  const { blackout, resOverride } = useQueryParams()

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/:customerId/:eventGuid" element={<Match blackout={blackout} resOverride={resOverride} />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App
